import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import {MESSAGES} from "../../../common/Messages";

function ChangeCrateDetailQuantityPopup(props) {
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [recordCount, setRecordCount] = useState(props?.selectedCrateDetail?.quantity); // For input
    const position = { of: "#accordion-containe2" };
    const handleClick = async () => {
        const count = parseFloat(recordCount); 
        if (!count || count <= 0) {
            alert(MESSAGES.ENTER_QUANTITY, MESSAGES.ERROR);
            return;
        }
    
        const quantity = parseFloat(props?.selectedCrateDetail?.quantity);
        if (count > quantity) {
            alert(MESSAGES.ENTER_QUANTITY_LESS_OR_EQUAL, MESSAGES.ERROR);
            return;
        }
    
        try {
            setLoadPanelVisible(true);
    
            const formData = new FormData();
            formData.append("RowId", props?.selectedCrateDetail?.rowid); 
            formData.append("QuantityActual", count);  
    
            const response = await axios.put(
                `${window._env_.REACT_APP_APIS}/im/CrateDetail/Update`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
    
            if (response.data === true) {
                alert(MESSAGES.QUANTITY_UPDATE_SUCCESS, MESSAGES.INFORMATION);
            } else {
                alert(MESSAGES.QUANTITY_UPDATE_ERROR, MESSAGES.ERROR);
            }
    
            if (props.onClosePopup) {
                props.onClosePopup();
                props.RefereshGrid();
            }
    
        } catch (error) {
            console.error("Error:", error);
            alert(MESSAGES.QUANTITY_UPDATE_ERROR, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };
    

    return (
        <div className="FormMt container-fluid" style={{ height: "96%", paddingTop: "0px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <TextBox
                        id="crateCount"
                        value={recordCount}
                        onValueChanged={(e) => setRecordCount(e.value)}
                        placeholder="Quantity"
                        width="100%"
                        mode="number"
                        inputAttr={{ min: 1 }}
                        labelMode='static'
                        label='Quantity'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <Button
                        text="Ok"
                        type="default"
                        stylingMode="contained"
                        width={120}
                        onClick={handleClick}
                    />
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ChangeCrateDetailQuantityPopup);
